<template>
  <!-- :style="this.$route.name === 'default' ? '' : 'border-top:3px solid rgb(224, 2, 38)'" -->
  <footer class="d-print-none" >
<!-- <footer class="footer "> -->

          <div class="d-none d-md-block" >
            <div class="container-fluid" >

              <div class="bg-light" style="padding:60px 40px 20px 40px;">

                      <div class="row bg-light " >
                          <div class="col-12 col-lg-2 text-left">

                            <img class="mb-2" src="@/assets/images/logo.png"  >
                            <div>
                              <span style="font-size: 16px;
                                  font-style: normal;
                                  font-weight: 400;
                                  line-height: 26px;" class="text-secondary">La mode pour tous</span>
                            </div>

                            <div class="mt-4">
                              <footersocial/>  
                            </div>
                          </div>

                          <div class="col-12 col-lg-10">

                              <div class="row">
                                    <div class="col-1 col-md-2 col-lg-3 col-xl-4 d-none d-lg-flex"/>
                                    <div class="col-md-4 col-lg-3 ">
                                          <div class="m-3">
                                            <span class="text-dark font-weight-bold" style="font-size: 14px;
                                              font-style: normal;
                                              font-weight: 500;
                                              line-height: 24px;"> Shop</span>
                                          </div>

                  
                                          <footershop/>
                                          
                                    </div>

                                    <div class="col-3">
                                          <div class="m-3">
                                            <span class="text-dark font-weight-bold" style="font-size: 14px;
                                              font-style: normal;
                                              font-weight: 500;
                                              line-height: 24px;"> Informations</span>
                                          </div>

                                          <footerinfo/>
                                    </div>

                                    <div class="col-3 col-lg-3 col-xl-2">
                                          <div class="m-3">
                                            <span class="text-dark font-weight-bold" style="font-size: 14px;
                                              font-style: normal;
                                              font-weight: 500;
                                              line-height: 24px;"> HA</span>
                                          </div>

                                          <footerha/>
                                    </div>

                              </div>

            
              </div>
      </div>


      <div class="row bg-light pt-4 mr-5" style="border-top: 1px solid var(--black-300, #CBCBCB);">
                <div class="col-6">

                            <span class="text-secondary font-size-14" style="font-size: 14px;
                      font-style: normal;
                      font-weight: 400;
                      line-height: 22px; ">© {{ new Date().getFullYear() }} HA Copyright </span>

                </div>
                <div class="col-6 text-right">
                  <div class="text-right text-dark mb-1">
                      <footerregion/>
                  </div>

                <a href="http://www.amiral.io" class="text-secondary mt-2" style="color:#92B9B1" target="_blank">powered by Amiral - INCENDO <small>v7.6.7</small></a>




                </div>
      </div>
</div>
      



</div>
      </div>


     

   
   
  </footer>
</template>

<script>
import footershop from "@/components/footer-shop.vue"
import footerinfo from "@/components/footer-info.vue"
import footerha from "@/components/footer-ha.vue"
import footerregion from "@/components/footer-region.vue"
import footersocial from "@/components/footer-social.vue"



export default ({
  name: "Faq",

  components: {
    footershop, footerinfo, footerha, footersocial, footerregion
  },


  data() {
    return {

     
     
    
    }
  },

  methods: {},
      
});
</script>
